import { Tooltip, Thumbnail, Button } from '@shopify/polaris';
import { ImageIcon } from '@shopify/polaris-icons';
import { useSafeAppBridge } from "../hooks";
export function ResourcePickerInline(props) {
    const shopify = useSafeAppBridge();
    const threshold = 4;

    return (
        <div className={"resource-picker-inline" + (props.errorType ? " has-error" : "")} onClick={async () => {
            if (shopify) {
                const res = await shopify.resourcePicker({
                    multiple: true,
                    action: 'select',
                    type: props.methodType === 1 ? "collection" : "product",
                    query: '',
                    selectionIds: props.selectionIds,
                });
                props.handleResourcePickerSelection(res, props.method, props.getType, props.buyType, props.excludeType, props.index);
            }
            else {
                //custom logic here
            }
        }}>
            {
                props.resources.length ?
                    <div className="selected-resources-inline">
                        {
                            props.resources.slice(0, threshold).map((item, index) => {
                                return <div key={index}>
                                    <Tooltip content={item.title + (item.subtitle ? ` ${item.subtitle}` : "")}>
                                        <Thumbnail source={item.imageUrl ? item.imageUrl : ImageIcon} size="small" />
                                    </Tooltip>
                                </div>
                            })
                        }
                        {
                            props.resources.length > threshold ?
                                <div><span className="more">+{props.resources.length - threshold}</span></div>
                                : null
                        }
                    </div>
                    :
                    <span>{props.methodType === 1 ? 'Select collections' : 'Select products'}</span>
            }
            <Button variant="tertiary" onClick={async () => {
                if (shopify) {
                    const res = await shopify.resourcePicker({
                        multiple: true,
                        action: 'select',
                        type: props.methodType === 1 ? "collection" : "product",
                        query: '',
                        selectionIds: props.selectionIds,
                    });
                    props.handleResourcePickerSelection(res, props.method, props.getType, props.buyType, props.excludeType, props.index);
                }
                else {
                    //custom logic here
                }
            }}>Browse</Button>
        </div>
    );
}